import React from 'react';
import { connect } from 'react-redux';
import { List } from '@ff-os/shared-react/components/list/List';
import { ListItem } from '@ff-os/shared-react/components/list/ListItem';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { SizeChoice } from '@gift-variable-plugins/size-attribute-shared/SizeAttributeOptions';
import { selectHasPreview, selectSizeChoiceById, selectSizeChoicesById, updateValueByIds } from '../_redux';
import { SizeAttributeDropdownItem } from './SizeAttributeDropdownItem';

const _SizeAttributeDropdownList = ({
    choices, selected, update, gap, hasPreview
}: Props) => (
    <List gap={gap}>
        {choices.map(c => (
            <ListItem
                key={c.value} bordered={gap !== undefined}
                onClick={() => update(c.value)} active={c.value === selected.value}>
                <SizeAttributeDropdownItem {...c} hasPreview={hasPreview} />
            </ListItem>
        ))}
    </List>
);

type Props = {
    variableIds: string[];
    choices: SizeChoice[];
    selected: SizeChoice;
    update: (value: string) => void;
    hasPreview: boolean;
    gap?: Parameters<typeof List>[0]['gap'];
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    hasPreview: selectHasPreview(state, ownProps.variableIds[0]!),
    selected: selectSizeChoiceById(state, ownProps.variableIds[0]!)!,
    choices: selectSizeChoicesById(state, ownProps.variableIds[0]!)!
});

const mapDispatchToProps = (dispatch: GiftPdpDispatch, ownProps: { variableIds: string[] }) => ({
    update: (size: string) => dispatch(updateValueByIds(ownProps.variableIds, size))
});

export const SizeAttributeDropdownList = connect(
    mapStateToProps,
    mapDispatchToProps
)(_SizeAttributeDropdownList);